

export const frontMatter = {
	slug: 'dockview-1.8.3-release',
	title: 'Dockview 1.8.3',
	tags: [
		'release'
	]
};
export const contentTitle = 'Release Notes';
export const metadata = {
  "permalink": "/blog/dockview-1.8.3-release",
  "source": "@site/blog/2023-09-17-dockview-1.8.3.md",
  "title": "Dockview 1.8.3",
  "description": "Please reference to docs @ dockview.dev.",
  "date": "2023-09-17T00:00:00.000Z",
  "formattedDate": "September 17, 2023",
  "tags": [
    {
      "label": "release",
      "permalink": "/blog/tags/release"
    }
  ],
  "readingTime": 0.3,
  "hasTruncateMarker": false,
  "authors": [],
  "frontMatter": {
    "slug": "dockview-1.8.3-release",
    "title": "Dockview 1.8.3",
    "tags": [
      "release"
    ]
  },
  "unlisted": false,
  "prevItem": {
    "title": "Dockview 1.8.5",
    "permalink": "/blog/dockview-1.8.5-release"
  },
  "nextItem": {
    "title": "Dockview 1.8.2",
    "permalink": "/blog/dockview-1.8.2-release"
  }
};
export const assets = {
"authorsImageUrls": [],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "🚀 Features",
  "id": "-features",
  "level": 2
}, {
  "value": "🛠 Miscs",
  "id": "-miscs",
  "level": 2
}, {
  "value": "🔥 Breaking changes",
  "id": "-breaking-changes",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Please reference to docs @ ", _jsx(_components.a, {
        href: "https://dockview.dev",
        children: "dockview.dev"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "-features",
      children: "🚀 Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Additional to DockviewDefaultTab component ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/321",
            children: "#321"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Additional group drop target options ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/316",
            children: "#316"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Intercept events to attach custom DataTransfer object to tabs ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/299",
            children: "#299"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Floating groups viewport overflow options ", _jsx(_components.a, {
            href: "https://github.com/mathuo/dockview/issues/326",
            children: "#326"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-miscs",
      children: "🛠 Miscs"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Bug: Close button on tab shouldn't bring panel to active state ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/issues/330",
          children: "#330"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-breaking-changes",
      children: "🔥 Breaking changes"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

